import { PermissionT } from "../types";

export const roofDesignTeam = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "roof_design_team");
  return !!p;
};

export default roofDesignTeam;
